var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VBtn',{attrs:{"text:color":"isConnected ? 'error' : 'primary'","loading":_vm.isLoading,"small":_vm.small},on:{"click":_vm.handleButtonClick}},[_vm._v(" "+_vm._s(_vm.isConnected ? 'Disconnect' : 'Connect')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }